import { useLocation } from 'react-router-dom'

import { ROOT, ROUTE } from 'const/routes'
import { isCurrentPathExactMatched } from 'components/Breadcrumbs/Breadcrumbs.hooks'

export const ROUTES_USING_NEW_PAGE_LAYOUT = [
  ROUTE.PORTAL_INVOICES,
  ROUTE.PORTAL_INVOICES_OVERVIEW,
  ROUTE.PORTAL_INVOICES_QUOTES,
  ROUTE.PORTAL_INVOICES_RECURRING,
  ROUTE.PORTAL_INVOICES_SETTINGS,
  ROUTE.PORTAL_INVOICES_SETTINGS_GENERAL,
  ROUTE.PORTAL_INVOICES_SETTINGS_REMINDERS,
  ROUTE.PORTAL_INVOICES_SETTINGS_CUSTOMISATION,
  ROUTE.PORTAL_INVOICES_SETTINGS_RECEIPTS,
  ROUTE.PORTAL_INVOICES_SETTINGS_USERS,
  ROUTE.PORTAL_INVOICES_SETTINGS_USERS_DETAILS,

  `${ROOT.PORTAL.INVOICING.INVOICES.INVOICE().EDIT.path}/settings`,
  `${ROOT.PORTAL.INVOICING.INVOICES.INVOICE().EDIT.path}/settings/general`,
  `${ROOT.PORTAL.INVOICING.INVOICES.INVOICE().EDIT.path}/settings/reminders`,
  `${
    ROOT.PORTAL.INVOICING.INVOICES.INVOICE().EDIT.path
  }/settings/customisation`,
  `${ROOT.PORTAL.INVOICING.INVOICES.INVOICE().EDIT.path}/settings/receipts`,
  `${ROOT.PORTAL.INVOICING.INVOICES.INVOICE().EDIT.path}/settings/users`,
  `${
    ROOT.PORTAL.INVOICING.INVOICES.INVOICE().EDIT.path
  }/settings/users/:invoiceSettingsUserId`,

  `${ROOT.PORTAL.INVOICING.INVOICES.NEW.path}/settings`,
  `${ROOT.PORTAL.INVOICING.INVOICES.NEW.path}/settings/general`,
  `${ROOT.PORTAL.INVOICING.INVOICES.NEW.path}/settings/reminders`,
  `${ROOT.PORTAL.INVOICING.INVOICES.NEW.path}/settings/customisation`,
  `${ROOT.PORTAL.INVOICING.INVOICES.NEW.path}/settings/receipts`,
  `${ROOT.PORTAL.INVOICING.INVOICES.NEW.path}/settings/users`,
  `${ROOT.PORTAL.INVOICING.INVOICES.NEW.path}/settings/users/:invoiceSettingsUserId`,

  `${ROOT.PORTAL.CARDS.SETTINGS.path}`,
  `${ROOT.PORTAL.CARDS.SETTINGS.OUTSTANDING_EXPENSES.path}`,

  ROUTE.PORTAL_INVOICES_RECURRING,
  ROUTE.PORTAL_INVOICES_INVOICE_CREATE,
  ROUTE.PORTAL_INVOICES_INVOICE_EDIT,
  ROUTE.PORTAL_INVOICES_INVOICE_LIST,
  ROUTE.PORTAL_INVOICES_INVOICE_DETAILS,
  ROUTE.PORTAL_INVOICES_QUOTE_CREATE,
  ROUTE.PORTAL_CARDS_ID,
  ROUTE.PORTAL_CARDS,

  ROOT.PORTAL.SETTINGS.CONNECTIONS.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.XERO_BANK_FEEDS.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.XERO_BANK_FEEDS_SETUP.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.XERO_BANK_FEEDS_MANAGE.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.XERO_PAYMENT_SERVICES.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.XERO_PAYMENT_SERVICES_SETUP.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.XERO_PAYMENT_SERVICES_MANAGE.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.XERO_PAYMENT_SERVICES_MANAGE.GENERAL.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.XERO_PAYMENT_SERVICES_MANAGE.RECEIPT.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.XERO_PAYMENT_SERVICES_MANAGE.USERS.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.XERO_PAYMENT_SERVICES_MANAGE.USERS.USER()
    .path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.HL_POS.MANAGE.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.ORACLE_POS.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.ORACLE_POS.MANAGE.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.ORACLE_POS.MANAGE.GENERAL.path,
  ROOT.PORTAL.SETTINGS.CONNECTIONS.ORACLE_POS.MANAGE.PAIRING.path,

  ROOT.PORTAL.ITEM_MANAGEMENT.path,
  ROOT.PORTAL.ITEM_MANAGEMENT.ITEMS.path,
  ROOT.PORTAL.ITEM_MANAGEMENT.CATEGORIES.path,
  ROOT.PORTAL.ITEM_MANAGEMENT.CATEGORIES.NEW.path,
  ROOT.PORTAL.ITEM_MANAGEMENT.CATEGORIES.CATEGORY().path,
  ROOT.PORTAL.ITEM_MANAGEMENT.CATEGORIES.CATEGORY().EDIT.path,
  ROOT.PORTAL.ITEM_MANAGEMENT.CATEGORIES.CATEGORY().ITEMS.path,
  ROOT.PORTAL.ITEM_MANAGEMENT.ITEMS.NEW.path,
  ROOT.PORTAL.ITEM_MANAGEMENT.ITEMS.ITEM().path,
  ROOT.PORTAL.ITEM_MANAGEMENT.ITEMS.ITEM().EDIT_DETAILS.path,
  ROOT.PORTAL.ITEM_MANAGEMENT.ITEMS.ITEM().EDIT_NOTES.path,
  ROOT.PORTAL.ITEM_MANAGEMENT.SETTINGS.path,

  ROOT.PORTAL.VIRTUAL_TERMINAL.path,
  ROOT.PORTAL.VIRTUAL_TERMINAL.HISTORY.path,

  ROOT.PORTAL.NOTIFICATIONS.path,
  ROOT.PORTAL.NOTIFICATIONS.PREFERENCES.path,
  ROOT.PORTAL.NOTIFICATIONS.PREFERENCES.PAYMENTS.path,
  ROOT.PORTAL.NOTIFICATIONS.PREFERENCES.ACCOUNTS.path,
  ROOT.PORTAL.NOTIFICATIONS.PREFERENCES.CARDS.path,
  ROOT.PORTAL.NOTIFICATIONS.PREFERENCES.USERS.path,

  ROUTE.PORTAL_PAYMENTS_DEPOSITS,
  ROUTE.PORTAL_PAYMENTS_DEPOSITS_SETTINGS,
  ROUTE.PORTAL_PAYMENTS_DEPOSITS_STATEMENTS,

  ROOT.PORTAL.PAYMENTS.SIM.path,
  ROOT.PORTAL.PAYMENTS.SIM.BILLING_HISTORY.path,
  ROOT.PORTAL.PAYMENTS.SIM.BILLING_HISTORY.STATEMENTS.path,
  ROOT.PORTAL.PAYMENTS.SIM.BILLING_ACCOUNT.path,

  ROUTE.PORTAL_HELP,

  ROUTE.PORTAL_PAYMENTS_DEVICES,

  ROUTE.PORTAL_PAYMENTS_REPORTS,

  ROUTE.PORTAL_PAYMENTS_SITES,
  ROUTE.PORTAL_PAYMENTS_SITES_CREATE_SITE,
  ROUTE.PORTAL_PAYMENTS_SITES_SITE_GENERAL,
  ROUTE.PORTAL_PAYMENTS_SITES_SITE_GENERAL_EDIT,
  ROUTE.PORTAL_PAYMENTS_SITES_SITE_PAYMENTS,
  ROUTE.PORTAL_PAYMENTS_SITES_SITE_RECEIPT,
  ROUTE.PORTAL_PAYMENTS_SITES_SITE_DEVICES,
  ROUTE.PORTAL_PAYMENTS_SITES_SITE_USERS,
  ROUTE.PORTAL_PAYMENTS_SITES_SITE_USERS_EDIT,
  ROUTE.PORTAL_PAYMENTS_SITES_SITE_USERS_CREATE_TYPE,
  ROUTE.PORTAL_PAYMENTS_SITES_SITE_USERS_CREATE_DETAILS,
  ROUTE.PORTAL_PAYMENTS_SITES_SITE_APPEARANCE,

  ROUTE.PORTAL_SETTINGS_USERS,
  ROUTE.PORTAL_SETTINGS_USERS_USER_EDIT,
  ROUTE.PORTAL_SETTINGS_USERS_USER_CREATE_TYPE,
  ROUTE.PORTAL_SETTINGS_USERS_USER_CREATE_DETAILS,

  ROUTE.PORTAL_SETTINGS_PROFILE,
  ROUTE.PORTAL_SETTINGS_PROFILE_PERSONAL,
  ROUTE.PORTAL_SETTINGS_PROFILE_PERSONAL_EDIT,
  ROUTE.PORTAL_SETTINGS_PROFILE_SECURITY,
  ROUTE.PORTAL_SETTINGS_PROFILE_SECURITY_CHANGE_NUMBER,
  ROUTE.PORTAL_SETTINGS_PROFILE_SECURITY_VALIDATE_CODE,
  ROUTE.PORTAL_SETTINGS_PROFILE_DOCUMENTS,

  ROUTE.PORTAL_SETTINGS_FEES_AND_PRICING,

  ROOT.PORTAL.TRANSACTIONS.path,
  ROOT.PORTAL.TRANSACTIONS.SPLITPAYMENT.SPLIT_PAYMENT_ID().path,

  ROOT.PORTAL.ACCOUNTS.path,
  ROOT.PORTAL.ACCOUNTS.TRANSACTIONS.path,
  ROOT.PORTAL.ACCOUNTS.TRANSFER.path,

  ROOT.PORTAL.ACCOUNTS.ACCOUNT().path,
  ROOT.PORTAL.ACCOUNTS.ACCOUNT().CARDS.path,
  ROOT.PORTAL.ACCOUNTS.ACCOUNT().CLOSE.path,
  ROOT.PORTAL.ACCOUNTS.ACCOUNT().DETAILS.path,
  ROOT.PORTAL.ACCOUNTS.ACCOUNT().EDIT.path,
  ROOT.PORTAL.ACCOUNTS.ACCOUNT().TRANSACTIONS.path,

  ROOT.PORTAL.CONTACTS.BUSINESSES.path,
  ROOT.PORTAL.CONTACTS.BUSINESSES.CONTACT().ACCOUNTS.path,
  ROOT.PORTAL.CONTACTS.BUSINESSES.CONTACT().GENERAL.path,
  ROOT.PORTAL.CONTACTS.BUSINESSES.CONTACT().INVOICES.path,
  ROOT.PORTAL.CONTACTS.BUSINESSES.CONTACT().INVOICES.INVOICE().path,
  ROOT.PORTAL.CONTACTS.BUSINESSES.CONTACT().PAYMENTS.path,

  ROOT.PORTAL.CONTACTS.PEOPLE.path,
  ROOT.PORTAL.CONTACTS.PEOPLE.CONTACT().ACCOUNTS.path,
  ROOT.PORTAL.CONTACTS.PEOPLE.CONTACT().GENERAL.path,
  ROOT.PORTAL.CONTACTS.PEOPLE.CONTACT().INVOICES.path,
  ROOT.PORTAL.CONTACTS.PEOPLE.CONTACT().INVOICES.INVOICE().path,
  ROOT.PORTAL.CONTACTS.PEOPLE.CONTACT().PAYMENTS.path,

  ROOT.PORTAL.REFERRAL.path,
]

export const useIsNewPageTemplateRoute = (): boolean => {
  const { pathname } = useLocation()

  return ROUTES_USING_NEW_PAGE_LAYOUT.some(
    (route) => pathname === route || isCurrentPathExactMatched(pathname)(route)
  )
}
